import { IrregularidadeEmpresaDTO, TipoIrregularidadeEmpresaDTO } from './../../../model/irregularidade-empresa.model';
import { Component, OnInit, HostListener } from "@angular/core";
import { IrregularidadeEmpresaService } from '../irregularidade_empresa.service';
import { DatePipe } from '@angular/common';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';

@Component({
    selector: 'app-irregularidade-empresa-pesquisa',
    templateUrl: './irregularidade_empresa.pesquisa.component.html',
    styleUrls: ['./irregularidade_empresa.pesquisa.component.scss'],
    standalone: false
})
export class IrregularidadeEmpresaPesquisaComponent implements OnInit {

  public tipoIrregularidadeEmpresa: TipoIrregularidadeEmpresaDTO[];
  public empresa: IrregularidadeEmpresaDTO[];
  public tipoIrregularidade: string;
  public cnpjEmpresa: string;
  public dataInicio: Date;
  public dataFim: Date;
  public pesquisado: boolean = false;
  public atributosPaginacaoComponenteListagem: EntityPagedResult<IrregularidadeEmpresaDTO>;
  public opcoesPaginacao: number[];
  public podeCadastrar: boolean;

  @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscarTodos();
    }

  ngOnInit(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];
      })
    this.buscarTipoIrregularidade();

    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  constructor(private service: IrregularidadeEmpresaService,
    private permissaoService : PermissaoService,
    private datePipe: DatePipe){}

  public mudancaPagina(novaPagina: EntityPagedResult<IrregularidadeEmpresaDTO>) {

    this.atributosPaginacaoComponenteListagem = novaPagina;
  }

  public buscarTodos() {
    this.pesquisado = false;
    let dto: any = {};
    if(this.tipoIrregularidade) {
      dto.tipo = this.tipoIrregularidade;
    }
    if(this.cnpjEmpresa) {
      dto.cnpj = this.cnpjEmpresa;
    }
    if(this.dataInicio) {
      dto.dataInicio = this.datePipe.transform(this.dataInicio, 'yyyyMMdd');
    }
    if(this.dataFim) {
      dto.dataFim = this.datePipe.transform(this.dataFim, 'yyyyMMdd');
    }
    this.service.buscarTodosTrancheAtual(dto)
      .subscribe((empresas: any) => {
      this.empresa = empresas.resultados;
      this.pesquisado = true
    })
  }

  public buscarTipoIrregularidade() {
    this.service.buscarTiposIrregularidade().subscribe((tipos: TipoIrregularidadeEmpresaDTO[]) => {
      this.tipoIrregularidadeEmpresa = tipos
    })
  }

  public limpar() {
    this.cnpjEmpresa = null;
    this.dataInicio = null;
    this.dataFim = null;
    this.pesquisado = false;
  }
}
